export default __webpack_public_path__ + "static/media/transactional-state-provider.487a00cd.svg";